import buildingIcon from '@assets/icons/building.svg';
import minerIcon from '@assets/icons/miner.svg';
import rackIcon from '@assets/icons/rack.svg';
import figures from '@components/ConnectionsEditor/figures';
import Icon from "@components/global/new/Icon/Icon";
import { ConsumerKind3, NodeFigure3 } from '@mobx/store/connections';
import lighten from "@utils/lighten";
import styles from "./NodeIcon.module.scss";

const icons: {[kind in ConsumerKind3]: string | undefined} = {
  "miner": minerIcon,
  "section": minerIcon,
  "rack": rackIcon,
  "building": buildingIcon,
}

interface NodeIconProps {
  icon: string;
  size?: number;
  figure?: NodeFigure3;
  figureColor?: string;
  consumer?: ConsumerKind3;
};

interface FigureProps {
  figure: NodeFigure3;
  icon: string;
  baseColor: string;
}

export const Figure3 = (props: FigureProps) => {
  const Fig = figures[props.figure];
  return (
    <div className={styles.figure}>
      {/*<Icon src={props.icon} className={styles.icon}/>*/}
      <Fig size={20} strokeWidth={90} fill={lighten(props.baseColor, 0.05)} stroke={lighten(props.baseColor, -0.5)}/>
    </div>
  )
}

const NodeIcon3 = (props: NodeIconProps) => {
  const size = props.size ?? 20;
  const iconSize = Math.round(0.8*size);
  return (
    <div 
      style={{width: size, height: size}}
      className={styles.container}
    >
      { props.figure
        ? <Figure3 icon={props.icon} figure={props.figure} baseColor={props.figureColor ?? "#DFF9E8"}/>
        : <Icon
            src={props.consumer ? (icons[props.consumer] ?? props.icon) : props.icon}
            style={{width: iconSize, height: iconSize}}
          />
      }
    </div>
  );
};

export default NodeIcon3;
